import { __makeTemplateObject } from "tslib";
/** @jsx jsx */
import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';
import { layers } from '@atlaskit/theme/constants';
var primitiveCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  pointer-events: none;\n"], ["\n  z-index: ", ";\n  pointer-events: none;\n"])), layers.tooltip());
var TooltipPrimitive = forwardRef(function TooltipPrimitive(_a, ref) {
    var style = _a.style, className = _a.className, children = _a.children, placement = _a.placement, testId = _a.testId;
    return (jsx("div", { role: "tooltip", ref: ref, style: style, className: className, css: primitiveCss, "data-placement": placement, "data-testid": testId }, children));
});
TooltipPrimitive.displayName = 'TooltipPrimitive';
export default TooltipPrimitive;
var templateObject_1;
//# sourceMappingURL=TooltipPrimitive.js.map